
// @ts-nocheck
import locale_en_45US_46json_14a1b245 from "#nuxt-i18n/14a1b245";
import locale_es_45ES_46json_79a2a635 from "#nuxt-i18n/79a2a635";

export const localeCodes =  [
  "en",
  "es"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_45US_46json_14a1b245",
      load: () => Promise.resolve(locale_en_45US_46json_14a1b245),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_45ES_46json_79a2a635",
      load: () => Promise.resolve(locale_es_45ES_46json_79a2a635),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      iso: "en-US",
      name: "English",
      files: [
        "/vercel/path0/apps/be.unity.org/i18n/locales/en-US.json"
      ]
    },
    {
      code: "es",
      iso: "es-US",
      name: "Español",
      files: [
        "/vercel/path0/apps/be.unity.org/i18n/locales/es-ES.json"
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_and_default",
  lazy: false,
  langDir: "./locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://be.unity.org",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    name: "English",
    files: [
      {
        path: "/vercel/path0/apps/be.unity.org/i18n/locales/en-US.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    iso: "es-US",
    name: "Español",
    files: [
      {
        path: "/vercel/path0/apps/be.unity.org/i18n/locales/es-ES.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/